import React from 'react'
import { cn } from '@/lib/utils'

/**
 * Skip Navigation component for keyboard accessibility
 * Provides skip links that become visible when focused
 */
export default function SkipNav() {
  return (
    <div className="sr-only focus-within:not-sr-only">
      <a
        href="#main-content"
        className={cn(
          "absolute top-0 left-0 z-skip-nav px-4 py-2 text-sm font-medium",
          "bg-primary text-primary-foreground",
          "border border-primary-foreground/20 rounded-br-md",
          "focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
          "transition-transform duration-200",
          "transform -translate-y-full focus:translate-y-0"
        )}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            const mainContent = document.getElementById('main-content')
            if (mainContent) {
              mainContent.focus()
              mainContent.scrollIntoView({ behavior: 'smooth' })
            }
          }
        }}
      >
        Skip to main content
      </a>
      <a
        href="#navigation"
        className={cn(
          "absolute top-0 left-0 z-skip-nav px-4 py-2 text-sm font-medium ml-32",
          "bg-primary text-primary-foreground",
          "border border-primary-foreground/20 rounded-br-md",
          "focus:outline-none focus:ring-2 focus:ring-ring focus:ring-offset-2",
          "transition-transform duration-200",
          "transform -translate-y-full focus:translate-y-0"
        )}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault()
            const navigation = document.getElementById('navigation')
            if (navigation) {
              navigation.focus()
              navigation.scrollIntoView({ behavior: 'smooth' })
            }
          }
        }}
      >
        Skip to navigation
      </a>
    </div>
  )
}